module.exports = __webpack_public_path__ + "img/powered-by-giphy-image.60eb011.png";